export default function HowItWorksScreen() {
    return <h1>How it works</h1>;
}